export default "__VITE_ASSET__tsztL_UA__"